import { Component, Input, OnInit } from "@angular/core";
import { OOVenue } from "../../models/oo-venue";

@Component({
	selector: "app-venue-info-footer",
	templateUrl: "./venue-info-footer.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class VenueInfoFooterComponent implements OnInit {
	@Input() ooVenue: OOVenue;
	@Input() footerMessage: string;

	constructor() {}

	ngOnInit(): void {}
}
